import quickShop from './ProductQuickShop';

const selectors = {
  quickShopTrigger: '[data-quickshop-trigger]',
  productCard: '[data-product-item]',
  productSwatch: '[data-product-swatch]',
  productImage: '[data-product-image]',
  variantImage: '[data-variant-image]',
  variantId: '[data-variant-id]',
};

/**
 * A single product item in a collection / list of products
 *
 * @export
 * @class ProductItem
 */
export default class ProductItem {
  /**
   * Creates an instance of ProductItem.
   * @param {HTMLElement} el
   */
  constructor(el) {
    this.el = el;

    this._initQuickShop();
    this._initCardSwatches();
  }

  /**
   * Bind quickshop to a trigger
   */
  _initQuickShop() {
    const trigger = this.el.querySelector(selectors.quickShopTrigger);

    if (!trigger) {
      return;
    }

    trigger.addEventListener('click', () => {
      const { productUrl, productHash } = this.el.dataset;

      quickShop.open(productUrl, productHash);
    });
  }

  _initCardSwatches() {
    const swatchInputs = this.el.querySelectorAll(selectors.productSwatch);
    const itemLinks = this.el.querySelectorAll('a');
    const productImage = this.el.querySelector(selectors.productImage);
    const productUrl = this.el.dataset.productUrl;

    /**
     * When a swatch input changes, update the variant select and image
     */
    swatchInputs.forEach(input => {
      input.addEventListener('change', () => {
        const variantImage = input.dataset.variantImage;
        const variantId = input.dataset.variantId;

        // Update the image
        productImage.src = variantImage;
        productImage.srcset = variantImage;

        // Update query URL
        itemLinks.forEach(link => {
          link.href = `${productUrl}?variant=${variantId}`;
        });
      });
    });
  }
}
